export const UNITS = [
  {
    key: "length",
    unit: "meter (m)",
    symbol: "m",
  },
  {
    key: "mass",
    unit: "kilogram (kg)",
    symbol: "kg",
  },
  {
    key: "time",
    unit: "second (s)",
    symbol: "s",
  },
  {
    key: "electric current",
    unit: "ampere (A)",
    symbol: "a",
  },
  {
    key: "thermodynamic temperature",
    unit: "kelvin (K)",
    symbol: "K",
  },
  {
    key: "amount of substance",
    unit: "mole (mol)",
    symbol: "mol",
  },
  {
    key: "luminous intensity",
    unit: "candela (cd)",
    symbol: "cd",
  },

  {
    key: "plane angle",
    unit: "radian (rad)",
    symbol: "rad",
  },
  {
    key: "solid angle",
    unit: "steradian (sr)",
    symbol: "sr",
  },
  {
    key: "frequency",
    unit: "hertz (Hz)",
    symbol: "Hz",
  },
  {
    key: "force",
    unit: "newton (N)",
    symbol: "N",
  },
  {
    key: "pressure, stress",
    unit: "pascal (Pa)",
    symbol: "Pa",
  },
  {
    key: "energy, work, quantity of heat",
    unit: "joule (J)",
    symbol: "J",
  },
  {
    key: "power, radiant flux",
    unit: "watt (W)",
    symbol: "W",
  },
  {
    key: "electric charge, quantity of electricity",
    unit: "coulomb (C)",
    symbol: "C",
  },
  {
    key: "electric potential difference, electromotive force",
    unit: "volt (V)",
    symbol: "V",
  },
  {
    key: "electric resistance",
    unit: "ohm (Ω)",
    symbol: "Ω",
  },
  {
    key: "electric conductance",
    unit: "siemens (S)",
    symbol: "S",
  },
  {
    key: "magnetic flux",
    unit: "weber (Wb)",
    symbol: "Wb",
  },
  {
    key: "magnetic flux density",
    unit: "tesla (T)",
    symbol: "T",
  },
  {
    key: "inductance",
    unit: "henry (H)",
    symbol: "H",
  },
  {
    key: "luminous flux",
    unit: "lumen (lm)",
    symbol: "lm",
  },
  {
    key: "illuminance",
    unit: "lux (lx)",
    symbol: "lx",
  },
  {
    key: "activity (of a radionuclide)",
    unit: "becquerel (Bq)",
    symbol: "Bq",
  },
  {
    key: "absorbed dose, specific energy (imparted), kerma",
    unit: "gray (Gy)",
    symbol: "Gy",
  },
  {
    key: "dose equiunitent",
    unit: "sievert (Sv)",
    symbol: "Sv",
  },
  {
    key: "catalytic activity",
    unit: "katal (kat)",
    symbol: "kat",
  },
];
